import { render } from "./Food.vue?vue&type=template&id=07324427&ts=true"
import script from "./Food.vue?vue&type=script&lang=ts"
export * from "./Food.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__